module.exports = __webpack_public_path__ + "img/Display-Ad-Disrupt-Image-con.745a085b.jpg";